import { render } from "./milestoneDates.vue?vue&type=template&id=28fe9236"
import script from "./milestoneDates.vue?vue&type=script&lang=js"
export * from "./milestoneDates.vue?vue&type=script&lang=js"

import "./milestoneDates.vue?vue&type=style&index=0&id=28fe9236&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__